'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface MembershipCTAProps {
  targetId?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  className?: string;
}

const MembershipCTA = ({
  targetId = 'membership',
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
}: MembershipCTAProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = () => {
    setIsLoading(true);

    requestAnimationFrame(() => {
      const el = document.getElementById(targetId);

      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }

      setTimeout(() => setIsLoading(false), 400);
    });
  };

  const variantClasses = {
    primary: 'bg-gradient-to-r from-primary to-secondary text-white shadow-lg',
    secondary: 'bg-accent text-accent-foreground',
    outline: 'border-2 border-primary text-primary hover:bg-primary hover:text-white',
  };

  const sizeClasses = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
  };

  return (
    <button data-component-id="src/components/common/MembershipCTA.tsx:53:4" data-component-path="src/components/common/MembershipCTA.tsx" data-component-line="53" data-component-end-line="79" data-component-file="MembershipCTA.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
      onClick={handleClick}
      disabled={isLoading}
      className={`
        ${variantClasses[variant]}
        ${sizeClasses[size]}
        ${fullWidth ? 'w-full' : ''}
        font-onest font-semibold rounded-lg
        transition-all duration-300
        hover:scale-105
        disabled:opacity-50
        flex items-center justify-center gap-2
        ${className}
      `}
    >
      {isLoading ? (
        <>
          <Icon data-component-id="src/components/common/MembershipCTA.tsx:70:10" data-component-path="src/components/common/MembershipCTA.tsx" data-component-line="70" data-component-end-line="70" data-component-file="MembershipCTA.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ArrowPathIcon%22%2C%22className%22%3A%22animate-spin%22%7D" name="ArrowPathIcon" size={20} className="animate-spin" />
          <span data-component-id="src/components/common/MembershipCTA.tsx:71:10" data-component-path="src/components/common/MembershipCTA.tsx" data-component-line="71" data-component-end-line="71" data-component-file="MembershipCTA.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22Processing...%22%7D">Processing...</span>
        </>
      ) : (
        <>
          <span data-component-id="src/components/common/MembershipCTA.tsx:75:10" data-component-path="src/components/common/MembershipCTA.tsx" data-component-line="75" data-component-end-line="75" data-component-file="MembershipCTA.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22Apply%20for%20Membership%22%7D">Apply for Membership</span>
          <Icon data-component-id="src/components/common/MembershipCTA.tsx:76:10" data-component-path="src/components/common/MembershipCTA.tsx" data-component-line="76" data-component-end-line="76" data-component-file="MembershipCTA.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ArrowRightIcon%22%7D" name="ArrowRightIcon" size={20} />
        </>
      )}
    </button>
  );
};

export default MembershipCTA;
